import {
  vehicleCategories,
  featuredVehicles,
  fleetVehicles,
  CategoryIconName,
  Vehicle,
} from '../data/easylease'
import { ShopConfig } from '../data/shopConfig'
export interface StorefrontCategory {
  label: string
  name: string
  icon: CategoryIconName
  prompt: string
}
/**
 * Resolve the merchant's configured categories into everything the storefront
 * needs to render them — short ribbon label, mark and the question handed to
 * the assistant. Unknown names still work, they just get the generic mark.
 */
export function storefrontCategories(config: ShopConfig): StorefrontCategory[] {
  return config.content.categories
    .filter((c) => c.visible)
    .map((c) => {
      const match = vehicleCategories.find((v) => v.name === c.name)
      return {
        label: match?.label ?? c.name,
        name: c.name,
        icon: match?.icon ?? 'all',
        prompt: match?.prompt ?? `Show me your ${c.name.toLowerCase()}`,
      }
    })
}
/** Products shown in the Featured row, per the merchant's chosen mode. */
export function storefrontFeatured(config: ShopConfig): Vehicle[] {
  const { featuredMode, featuredIds } = config.content
  if (featuredMode === 'hidden') return []
  if (featuredMode === 'manual')
    return featuredIds
      .map((id) => fleetVehicles.find((v) => v.id === id))
      .filter((v): v is Vehicle => Boolean(v))
  return featuredVehicles
}
/** Split a headline so the merchant name and the closing word can be styled. */
export function splitHeadline(headline: string, brandName: string) {
  const words = headline.trim().split(/\s+/)
  const last = words.length > 1 ? words[words.length - 1] : ''
  const leading = last ? words.slice(0, -1) : words
  return {
    leading,
    last,
    brandTokens: brandName.trim().split(/\s+/),
  }
}
